import { render, staticRenderFns } from "./Gap.vue?vue&type=template&id=98b4835c&"
import script from "./Gap.vue?vue&type=script&lang=js&"
export * from "./Gap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports